import React from 'react';
import { Field } from 'redux-form'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentRemove from 'material-ui/svg-icons/content/remove';

import MenuItem from 'material-ui/MenuItem';

import FormAutoComplete2 from './FormAutoComplete2'
import FormSelect from './FormSelect'
import FormText from './FormText'

import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons';
import FormLabel from "./FormLabel";
import Divider from "material-ui/Divider";

import moment from "moment"

class FormCostContents extends  React.Component {

    componentDidMount() {

        const {
            fields,
            dataSource,
            dataSourceType,
            isNew
        } = this.props

        if (isNew && fields && fields.length == 0) {
            if (dataSource) {
                const year = Number(moment().format("YYYY"))
                const month = Number(moment().format("M"))
                dataSource.forEach(x => {
                    if (dataSourceType == 'autoComplete') {
                        fields.push({year, month, costName: x.textKey})
                    } else {
                        fields.push({year, month, costId: x.id})
                    }
                })
            }
        }

    }

    render() {

    const {
        kind,
      fields,
      dataSourceConfig,
      dataSourceType,
      dataSource,
      resultDisable,
      status,
      org
    } = this.props

    const year = moment().format("YYYY");

    const yearList = []
    for (let i = Number(year) - 5; i < Number(year) + 6; i++) {
        yearList.push(i)
    }

    return (
      <div style={{marginBottom: 20}}>

        <div className="row">

          {fields && fields.map((name, index) => {

            return (
              <div className="col-12" key={index}
                   style={{backgroundColor: commons.rowColor(index)}}>
                <div className="row" style={{marginTop: 5, marginBottom: 10}}>
                    <div className="col">
                        <div className="row">

                            {
                                !kind.startsWith("労務費") &&
                                <div className="col-4">
                                    <div className="row">
                                        <div className="col">
                                            <Field
                                                name={`${name}.year`}
                                                component={FormSelect}
                                                style={{ width: '100%' }}
                                                label="年"
                                                disabled={status === 3}
                                            >
                                                {
                                                    yearList && yearList.map((x, index) => {
                                                        return (<MenuItem key={index} value={x} primaryText={x} />)
                                                    })
                                                }
                                            </Field>
                                        </div>
                                        <div className="col">
                                            <Field
                                                name={`${name}.month`}
                                                component={FormSelect}
                                                style={{ width: '100%' }}
                                                label="月"
                                                disabled={status === 3}
                                            >
                                                {
                                                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((x, index) => {
                                                        return (<MenuItem key={index} value={x} primaryText={x} />)
                                                    })
                                                }
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="col-3">

                                {dataSourceType === 'select' &&
                                    <Field
                                        name={`${name}.costId`}
                                        component={FormSelect}
                                        style={{ width: '100%' }}
                                        label="項目"
                                        disabled={status === 3}
                                    >
                                        {
                                            dataSource && dataSource.map((x, index) => {
                                                return (<MenuItem key={index} value={x.id} primaryText={x.name} />)
                                            })
                                        }
                                    </Field>
                                }

                                {dataSourceType === 'autoComplete' &&

                                    <Field
                                        name={`${name}.costName`}
                                        dataSourceConfig={dataSourceConfig}
                                        dataSource={dataSource}
                                        component={FormAutoComplete2}
                                        disabled={status === 3}
                                        floatingLabelText="項目"
                                        filter={(searchText, key) => {
                                            return searchText !== '' && key.indexOf(searchText) !== -1
                                        }}
                                        textFieldStyle={{ width: '100%'}}
                                        style={{ width: '100%' }}
                                    />
                                }
                            </div>

                            <div className="col-2">
                                <Field name={`${name}.result`} component={FormText} label="実績"
                                       style={{ width: '100%' , color: colors.grey400}}
                                       format={commons.dispMoney}
                                       normalize={commons.dispMoney}
                                       disabled={resultDisable ? true : false || status === 3 || (org && org[index] && org[index].importDate ? true : false)}
                                />
                            </div>

                            {/*{*/}
                                {/*org[index].roumuDiff && (*/}
                                    {/*<div className="col-2">*/}
                                        {/*<FormLabel*/}
                                            {/*title='時間'*/}
                                            {/*name='test'*/}
                                            {/*value={commons.minutesToHour(org[index].roumuDiff)}*/}
                                        {/*/>*/}
                                    {/*</div>*/}
                                {/*)*/}
                            {/*}*/}

                            <div className="col-2">
                                <Field name={`${name}.budget`} component={FormText} label="予算" style={{ width: '100%' }} format={commons.dispMoney} normalize={commons.dispMoney} disabled={status === 3} />
                            </div>

                        </div>

                        <div className="row">
                            <div className="col">
                                <Field name={`${name}.comment`} component={FormText} label="備考" style={{ width: '100%' }} disabled={status === 3} />
                            </div>
                        </div>
                    </div>

                    <div className="col-1">
                        <div style={{ display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '100%', paddingTop: '5px' }}>
                            <FloatingActionButton zDepth={0}
                                                  mini={true}
                                                  backgroundColor={colors.red300}
                                                  onClick={() => {
                                                      fields.remove(index)
                                                  }}
                                                  disabled={
                                                      (org && org[index] && org[index].importDate)
                                                          || (resultDisable && org && org[index] && org[index].result)
                                                          ? true : false}
                            >
                                <ContentRemove />
                            </FloatingActionButton>
                        </div>

                    </div>

                </div>
            </div>
            )

          })}

        </div>

        <div className="row">

            <div className="col-11" ></div>

          <div className="col-1" style={{ marginTop: 10 }}>
              <div style={{ display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '100%', paddingTop: '5px' }}>
                    <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} disabled={status === 3}
                      onClick={() => {
                        const year = Number(moment().format("YYYY"))
                        const month = Number(moment().format("M"))
                        fields.push({year, month})
                      }}>
                      <ContentAdd />
                    </FloatingActionButton>
              </div>
          </div>
        </div>

      </div>

    )

  }

}

export default FormCostContents


// WEBPACK FOOTER //
// ./src/components/FormCostContents.js